// extracted by mini-css-extract-plugin
module.exports = {"comp":"JD_comp__7RA_P"};